import ApiHeaderKey from "core/constants/api-header-key";
import { MahPaymentRequest } from "core/models/mah-payment.request";
import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";
import { AmountWithCurrency, CefApiError } from "./types";
import { activityLogArea } from "../user-tracking-helper";
import userService from "../user.service";

export type PaymentResponse = {
    paymentResponse: PaymentResponseResponse
}

export type PaymentResponseResponse = {
    paymentResponseDetail: PaymentResponseDetail,
    errorResponse: CefApiError
}

export type PaymentResponseDetail = {
    redirectUrl: string,
    success: boolean,
    responseMessage: string,
    transactionId: string,
    token: string
}

export type PaymentStatusResponse = {
    paymentStatusResponse: PaymentStatusResponseResponse;
}

export type PaymentStatusResponseResponse = {
    paymentStatusResponseDetail: PaymentStatusResponseDetail;
    errorReponse: CefApiError;
}

export type PaymentStatusResponseDetail = {
    amount: TransactionAmount;
    businessUnit?: string;
    channel: string;
    country: string;
    customerNumber: string;
    date: string;
    exceptionMessage?: string;
    message?: string;
    receiptNumber?: string;
    responseCode?: string;
    responseMessage?: string;
    smartcardNumber?: string;
    status: string;
    success: boolean;
    transactionId: string;
    vendorCode?: string;
    vendorName?: string;
    vendorTransactionId?: string;
}

// {
//     "paymentStatusResponse": {
//         "paymentStatusResponseDetail": {
//             "success": false,
//             "customerNumber": "217076976",
//             "channel": "CefDigitalIntegration",
//             "vendorName": null,
//             "responseCode": null,
//             "status": "Pending",
//             "country": "Ghana",
//             "responseMessage": null,
//             "date": "2023-06-09T09:44:40.057",
//             "message": null,
//             "receiptNumber": null,
//             "smartcardNumber": null,
//             "vendorTransactionId": null,
//             "vendorCode": null,
//             "businessUnit": null,
//             "exceptionMessage": null,
//             "transactionId": "139186661",
//             "amount": {
//                 "value": 408.87,
//                 "currencyCode": "ghs",
//                 "currencySymbol": "GH₵"
//             }
//         }
//     }
// }

export type TransactionAmount = AmountWithCurrency & {
    localValue?: AmountWithCurrency
}

class PaymentService extends BaseCefCommercialService {
    constructor() {
        super(activityLogArea.mahPayment);
        this.setBaseUrl(`CEFCommPayments/${CefVersion}/customer/payment`);
        this.validateCustomerNumber();
    }

    getRequestHeaders() {
        const headers = super.getRequestHeaders();

        const getUserIp = async () => {
            headers[ApiHeaderKey.clientIp] = await userService.getIpAddress();
        };

        getUserIp();
        return headers;
    }

    makePayment(request: MahPaymentRequest) {
        request.customerNumber = this.customerNumber;
        return this.createPromiseRequest(undefined).post<PaymentResponse>(request);
    }

    paymentStatus(transactionId: number) {
        return this.createPromiseRequest(transactionId.toString()).get<PaymentStatusResponse>();
    }
}

export default PaymentService;
